import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths'
import React, { useCallback, useContext, useMemo, useState } from 'react'
import { seasonalHelpers } from '../cnr/reducers/reducerHelpers/seasonalHelpers';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { useSeasonalData } from './useSeasonals';
import { useSportsCollection } from './useSportsCollection';
import { where, writeBatch } from 'firebase/firestore';
import _ from 'lodash';
import { dataFix } from 'global/common/dataFix';

const _rosterCollectionNames = {
  accessTeams: {
    parentDoc: '_sportsAccess_teams',
    mapField: 'teams',
  },
  accessSports: {
    parentDoc: '_sportsAccess_sports',
    mapField: 'sports',
  },
  sportsAccess: {
    parentDoc: '_sportsAccess',
    mapField: 'accessEmails',
  },
  teamInfo: {
    parentDoc: '_teamsInfo',
    mapField: 'teamsInfo',
  },
}

export const useSportsAccess = () => {

  const _allowAccessUpdate = true

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns ?? {}
  const { mainDb } = app_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info } = sportsSeason_state ?? {}
  const { sportsKey, currentSeason, _sportsAbr } = currentSeason_info ?? {}

  const _sdh = useSeasonalData()

  const [updating, setUpdating] = useState()

  const updateTeamInfo = useCallback(async ({ teamKey, teamInfo }) => {

    const rc = _rosterCollectionNames.teamInfo
    const pd = rc.parentDoc
    const mf = rc.mapField

    setUpdating(true)

    const batch = writeBatch(mainDb);

    const dataToUpdate = dataFix.cleanForFirebase(teamInfo, { removeUnderscore: true })

    const _pks = seasonalHelpers.getPks(pathViews, currentSeason, sportsKey, ['teams', 'sportsYears', 'sports'])

    const _sportsYearCollectionItem = await _sdh.getSports_collectionItem(_pks, pd, true)
    // const _sportsYearCollectionItemm = await _sdh.getSports_collectionItem(_pks, _rosterCollectionNames.sportsAccess.parentDoc, true)

    if (!_sportsYearCollectionItem) {
      // add a new doc
      const docKey = database_fns.get_docKey()
      const newDocKey = docKey//`${_sportsAbr}_${docKey}`
      const refPath = createRefPath_event(pathViews, [pd, newDocKey])
      const dtu = {
        parentKeys: _pks,
        [mf]: {
          [teamKey]: {
            ...dataToUpdate
          }
        }
      }
      console.log('refPath', refPath)
      console.log('dtu', dtu)
      database_fns.set_doc(refPath, dtu, false, null, batch); // Assuming doc_update returns a promise
    } else {
      const { _itemKey } = _sportsYearCollectionItem ?? {}
      const refPath = createRefPath_event(pathViews, [pd, _itemKey])
      const dtu = { [`${mf}.${teamKey}`]: { ...dataToUpdate } }
      console.log('refPath', refPath)
      console.log('dtu', dtu)
      database_fns.update_doc(refPath, dtu, null, batch); // Assuming doc_update returns a promise
    }

    if (_allowAccessUpdate) {
      await batch.commit()
      setUpdating(false)
    }
  }, [])

  const updateAccess = useCallback(async ({ teamKey, teamAccess, accessByTeam, accessByEmail }) => {

    const rc = _rosterCollectionNames.sportsAccess
    const pd = rc.parentDoc
    const mf = rc.mapField

    setUpdating(true)

    const batch = writeBatch(mainDb);

    const dataToUpdate = dataFix.cleanForFirebase(accessByEmail, { removeUnderscore: true })

    console.group('updateAccess')
    console.log('dataToUpdate', dataToUpdate)

    const _pks = seasonalHelpers.getPks(pathViews, currentSeason, sportsKey, ['teams', 'sportsYears', 'sports'])

    const _sportsYearCollectionItem = await _sdh.getSports_collectionItem(_pks, pd, true)
    // const _sportsYearCollectionItemm = await _sdh.getSports_collectionItem(_pks, _rosterCollectionNames.sportsAccess.parentDoc, true)

    console.log('_sportsYearCollectionItem', _sportsYearCollectionItem)

    if (!_sportsYearCollectionItem) {
      // add a new doc
      const docKey = database_fns.get_docKey()
      const newDocKey = docKey // `${_sportsAbr}_${docKey}`
      const refPath = createRefPath_event(pathViews, [pd, newDocKey])
      const dtu = {
        parentKeys: _pks,
        [_rosterCollectionNames.accessTeams.mapField]: { ...dataToUpdate }
      }
      console.log('refPath', refPath)
      console.log('dtu', dtu)
      database_fns.set_doc(refPath, dtu, false, null, batch); // Assuming doc_update returns a promise
    } else {
      const { _itemKey } = _sportsYearCollectionItem ?? {}
      const refPath = createRefPath_event(pathViews, [pd, _itemKey])
      const dtu = {
        [`${mf}`]: { ...dataToUpdate }
      }
      console.log('refPath', refPath)
      console.log('dtu', dtu)
      database_fns.update_doc(refPath, dtu, null, batch); // Assuming doc_update returns a promise
    }

    if (_allowAccessUpdate) {
      await batch.commit()
      setUpdating(false)
    }
    setUpdating(false)

    console.groupEnd()
  }, [])

  const getAccess = useCallback(async ({ callback }) => {

    const rc = _rosterCollectionNames.sportsAccess
    const pd = rc.parentDoc
    const mf = rc.mapField

    const cb_teams = (data) => {
      if (!_.isEmpty(data)) {
        const { parentKeys } = data
        const [key, value] = _.toPairs(data)[0];
        const accessByEmail = value?.[mf]

        // console.log('teams', teams)
        // const accessByEmail = {};

        // _.forEach(teams, (accessList, teamKey) => {
        //   _.forEach(accessList, ({ name, accessLevel }) => {

        //     accessByEmail[name] ??= {
        //       name: name,
        //       teams: {}
        //     };

        //     accessByEmail[name].teams[teamKey] = {
        //       accessLevel
        //     };

        //   });
        // });

        // const accessByTeams = {};

        // _.forEach(accessByEmail, (userAccess, email) => {
        //   _.forEach(userAccess.teams, (access, teamKey) => {

        //     accessByTeams[teamKey] ??= [];

        //     accessByTeams[teamKey].push({
        //       name: email,
        //       ...access
        //     });

        //   });
        // });

        callback({
          parentKey: key,
          // [mf]: teams,
          accessByEmail,
          // accessByTeams
        })
      } else {
        callback({ [mf]: null })
      }
    }

    const refPath = createRefPath_event(pathViews, [pd])
    const wheres = getWheres_sport({ pathViews, currentSeason, sportsKey })
    database_fns.get_data({
      refPath,
      callback: cb_teams,
      wheres
    })
  }, [])

  return { updating, getAccess, updateAccess, allowAccessUpdate: _allowAccessUpdate, updateTeamInfo }
}

const getWheres_sport = ({ pathViews, currentSeason, sportsKey }) => {

  let ignores = ['teams', 'sportsYears']

  if (pathViews.sports) {
    ignores = ['teams', 'sportsYears', 'sports']
  }

  const _pks = seasonalHelpers.getPks(pathViews, currentSeason, null, ignores)

  const wheres = _.map(_pks, (value, pk) => {
    return where('parentKeys.' + pk, '==', value)
  })
  return wheres
}

const removeEmptyValues = (obj) => {
  if (_.isArray(obj)) {
    const arr = obj
      .map(removeEmptyValues)
      .filter(v =>
        !_.isNil(v) &&
        v !== "" &&
        !(_.isArray(v) && v.length === 0) &&
        !(_.isPlainObject(v) && _.isEmpty(v))
      );

    return arr;
  }

  if (_.isPlainObject(obj)) {
    return _.pickBy(
      _.mapValues(obj, removeEmptyValues),
      v =>
        !_.isNil(v) &&
        v !== "" &&
        !(_.isArray(v) && v.length === 0) &&
        !(_.isPlainObject(v) && _.isEmpty(v))
    );
  }

  return obj;
};